/** Keep a discretionary percentage and pound amount in step. */
export function syncDiscretionary(value, field, sectionTotal) {
  const total = Number(sectionTotal) || 0;
  if (field === "percentage") {
    const percentage = value;
    if (value === "" || total <= 0) return { percentage, amount: value === "" ? "" : "0.00", basis: "percentage" };
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) return { percentage: value, amount: "", basis: "percentage" };
    return { percentage: value, amount: ((numeric * total) / 100).toFixed(2), basis: "percentage" };
  }
  const amount = value;
  if (value === "" || total <= 0) return { percentage: value === "" ? "" : "0.0000", amount, basis: "amount" };
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return { percentage: "", amount: value, basis: "amount" };
  return { percentage: ((numeric / total) * 100).toFixed(4), amount: value, basis: "amount" };
}

/** Pounds that keep a saved percentage when the section total changes. */
export function poundsFromPercentage(percentage, sectionTotal) {
  if (percentage == null || percentage === "") return "";
  const total = Number(sectionTotal) || 0;
  return ((Number(percentage) * total) / 100).toFixed(2);
}

/**
 * Pounds and percentage shown for one unit.
 * Budget line totals win. When those are still £0, percentages split the cash
 * already allocated so the row total moves as the percentage is typed.
 */
export function liveShare({ percentage, amount, edit, sectionTotal, savedPot }) {
  const lines = Number(sectionTotal) || 0;
  const saved = Number(savedPot) || 0;
  const base = lines > 0 ? lines : saved;
  if (edit?.basis) {
    const field = edit.basis === "amount" ? "amount" : "percentage";
    const value = field === "amount" ? edit.amount : edit.percentage;
    const synced = syncDiscretionary(value ?? "", field, base);
    if (base <= 0 && field === "percentage" && synced.percentage !== "") {
      return { ...synced, amount: "" };
    }
    return synced;
  }
  if (lines > 0) {
    const pct = Number(percentage);
    if (!pct && Number(amount) > 0 && saved > 0) {
      const ratio = Number(amount) / saved;
      return {
        percentage: trimShare(ratio * 100),
        amount: (ratio * lines).toFixed(2),
        basis: "percentage",
      };
    }
    return {
      percentage: percentage ?? "",
      amount: poundsFromPercentage(percentage, lines),
      basis: "percentage",
    };
  }
  const implied = saved > 0 && Number(amount) > 0 ? trimShare((Number(amount) / saved) * 100) : (percentage ?? "");
  return { percentage: implied, amount: amount ?? "", basis: "amount" };
}

function trimShare(value) {
  return Number(value).toFixed(4).replace(/\.?0+$/, "");
}
